import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { Condition } from '../model/condition';

@Injectable({
    providedIn: 'root'
  })
  export class ConditionService{
  
    constructor(private _restClientService : RestClientService) 
    {}

    getConditionsByRequestItemId(requestItemId) {
      return this._restClientService.load<Condition[]>('condition/conditions-by-resquestitemid/'+requestItemId);
    }
    
    getConditionById(conditionId) {
      return this._restClientService.load<Condition>('condition/conditions-by-id/'+conditionId);
    }
      
    
    putCondition(condition: Condition) {
      return this._restClientService.put<void>('condition/update-condition', condition);
    }

    
    postCondition(condition: Condition) {
      return this._restClientService.save<void>('condition/add-condition', condition);
    }

    deleteCondition(conditionId){
      return  this._restClientService.delete<void>('condition/delete-condition/'+conditionId);
    }

    
}      

    